import { useTranslation } from "@opendash/i18n";
import { Form, Switch } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext } from "../../../context/PathContext";
import { FormItemPath } from "../../../types/Config";

type Props = {};

export const HiddenCheckbox = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <Form.Item<FormItemPath>
      label={t("maintenance:ticket.create.config.general.hidden.label")}
      name={[...path, "hidden"]}
      valuePropName="checked"
      layout="vertical"
    >
      <Switch
        unCheckedChildren={t(
          "maintenance:ticket.create.config.general.hidden.unCheckedChildren"
        )}
        checkedChildren={t(
          "maintenance:ticket.create.config.general.hidden.checkedChildren"
        )}
      />
    </Form.Item>
  );
});
